var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmbedPlayerShell',{attrs:{"episode":_vm.episode,"episodes":_vm.episodes}})
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/embedplayer/EmbedPlayer.vue